import { useState } from 'react';
import {
  arrayOf,
  bool,
  element,
  func,
  oneOf,
  shape,
  string,
} from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  IconButton,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import {
  Close as CloseIcon,
  Fullscreen as FullscreenIcon,
} from '@material-ui/icons';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {},
  firstButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  secondButton: {
    position: 'absolute',
    right: theme.spacing(6),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function Modal(props) {
  const {
    actions,
    canFullScreen,
    children,
    events,
    fullWidth,
    maxWidth,
    open,
    title,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [forceFull, setForceFull] = useState(false);

  const { onClose } = events;

  return (
    <Dialog
      disableBackdropClick
      fullWidth={fullWidth}
      fullScreen={fullScreen || forceFull}
      maxWidth={maxWidth}
      onClose={onClose}
      open={open}
      aria-labelledby="simple-dialog-title"
    >
      {title && <DialogTitle
        id="simple-dialog-title"
        children={title}
      />}

      {(canFullScreen && !fullScreen) && (<IconButton
        aria-label="fullscreen"
        children={<FullscreenIcon />}
        className={onClose ? classes.secondButton : classes.firstButton}
        onClick={() => setForceFull(!forceFull)}
      />)}

      {onClose &&
        <IconButton
          aria-label="close"
          className={classes.firstButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      }

      {children && (
        <DialogContent
          children={children}
          dividers
        />
      )}

      {!!actions.length && <>
        <DialogActions>
          {actions.map((item, index) => (
            <Button
              children={item.label}
              color={item.color}
              disabled={item.disabled}
              form={item.form}
              key={index}
              startIcon={item.icon}
              style={{
                ...(item.hidden ? {
                  display: 'none',
                } : {}),
                ...(item.left ? {
                  marginRight: 'auto',
                } : {}),
                ...(item.color === 'error' ? {
                  color: 'white',
                  backgroundColor: red[500],
                  '&:hover': {
                    backgroundColor: red[900],
                  },
                } : {}),
              }}
              type={item.type}
              variant={item.color ? 'contained' : 'text'}
              onClick={item.fn || item.action}
            />
          ))}
        </DialogActions>
      </>}

    </Dialog >
  );
}

Modal.defaultProps = {
  actions: {},
  events: {},
  fullWidth: true,
  maxWidth: 'sm',
  open: false,
};

Modal.propTypes = {
  actions: arrayOf(shape({
    color: oneOf([
      'error',
      'primary',
      'secondary',
    ]),
    disabled: bool,
    fn: func,
    icon: element,
    label: string,
  })),
  canFullScreen: bool,
  children: element,
  events: shape({
    onClose: func,
  }),
  fullWidth: bool,
  maxWidth: oneOf([
    'lg',
    'md',
    'sm',
    'xl',
    'xs',
  ]),
  open: bool,
  title: string,
};

export default Modal;
